import { render, staticRenderFns } from "./bandPill.vue?vue&type=template&id=2b7ea21e&scoped=true&"
import script from "./bandPill.vue?vue&type=script&lang=js&"
export * from "./bandPill.vue?vue&type=script&lang=js&"
import style0 from "./bandPill.css?vue&type=style&index=0&id=2b7ea21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ea21e",
  null
  
)

export default component.exports